import React from "react";
import "./StillTrust.css";
import OngoingTopBg from "../assets/images/ongoing-top-bg.png";
import RotateIcon from "../assets/images/rotate-icon.png";
import CalendarIcon from "../assets/images/calendar-icon.png";
import CareerIcn01 from "../assets/images/career-icn01.png";
import CareerIcn02 from "../assets/images/career-icn02.png";
import CareerIcn03 from "../assets/images/career-icn03.png";

export const StillTrust = () => {
  return (
    <div className="before-you-ask-section">
      <div className="before-you-ask_container">
        <div className="ongoing-section">
          <div className="ongoing-text-bar">
          <span>Registrations Ongoing!</span> 
          <div className="ongoing-top-bg"><img src={OngoingTopBg} alt="" /></div>
          <div className="ongoing-title">
            <img src={RotateIcon} alt="" />
            <h2>Enroll Now & Get <b>Instant <br />Access</b> for Lifetime</h2>
            <img src={CalendarIcon} alt="" />
          </div>
           <div className="report-text"><p>Graduates report promotions, raises, or new <br />opportunities within 3 months.</p></div>
           <div className="btn-access"><a href="https://pages.razorpay.com/ROBOAI-I90" target="_blank">Enroll Now to Access</a></div>
           <div className="weeks-career-bar">
            <div className="weeks-career-box">
              <div className="career-icon"><img src={CareerIcn01} alt="" /></div>
              <p className="week-ptag">6 Weeks of Career-<br />Oriented Training</p>
            </div>
            <div className="weeks-career-box">
              <div className="career-icon"><img src={CareerIcn02} alt="" /></div>
              <p className="week-ptag">Learn by Doing, Not<br />Watching</p>
            </div>
            <div className="weeks-career-box">
              <div className="career-icon"><img src={CareerIcn03} alt="" /></div>
              <p className="week-ptag">Lifetime Access with All<br />Future Updates</p>
            </div>                        
           </div>
          </div>
        </div>
      </div>
    </div>
  );
};
